<template>
    <div class="voice-panel-hld">
        <div class="microphone-image">
            <img src="../assets/Images/chatgpt/listening-speaker.svg"/>
        </div>
        <div class="audio-instruction-text">
            <h4>Go ahead, I'm listening<span class="animated-dot">...</span></h4>
        </div>
        <v-btn @click="CloseVoiceBox()" fab x-small class="close-voice-box"><v-icon color="#000" size="22px">mdi-close</v-icon></v-btn>
    </div>
</template>
<script>
export default {
    components: {
    },
    props: {
        visible: {
        type: Boolean,
        required: true
        }
    },
    data() {
        return {
        }
    },
    computed: {
        
    },
    watch: {},
    created() {},
    mounted() {},
    methods: {
        CloseVoiceBox(){
            this.$parent.OpenVoiceBox = false; 
        }
    },

}
</script>
